<template>
    <div class="topSpace">
        <div class="invoice-table margin-bottom-lg topSpace" style="width:100%;">
            <table class="table table-striped">
                <thead>
                <tr>
                    <th class="auto-style1">DESCRIPTION</th>
                    <th class="auto-style2">QTY</th>
                    <th class="auto-style3">TOTAL</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="item in list">
                    <td>
                        <span id="masterBody_rptItems_lblServiceDescription_0" class="font-weight-bold">{{ item.name }}</span>
                    </td>
                    <td class="text-center">
                        <span id="masterBody_rptItems_lblQuantity_0">{{ item.quantity }}</span>
                    </td>
                    <td class="total text-right">{{ item.total }}</td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>


    <!-- end of another qustion -->
</template>

<script>
export default {
    props: {
        list: Array
    }
}
</script>
